import {GameFlowController} from '../../components/game-flow-controller.js';

export function goToGame(event: MouseEvent) {
    //The original function in Unity was called GoToGameViaToken. But there was nothing token
    // related in the function and no other go-to-game function was there. So I just renamed it to GoToGame.
    const gameFlow = GameFlowController.instance;
    if (gameFlow.canChangeMenu) {
        gameFlow.startGameMode(event);
    }
}
